import { Link } from "react-router-dom";
import { Timestamp } from "@/components/ui/timestamp";
import { Chip } from "@/components/ui/chip";
import { GateStatusChip } from "./gate-vocabulary";
import { severityTotal, type GateHistoryView } from "./gate-data";

/**
 * Recent gate results, newest build first: status plus the new / fixed /
 * regressed counts, one row per build. Used on the build page (same
 * branch and environment) and in the Overview gate card.
 */
export function GateHistoryList({
  projectId,
  history,
  currentBuildId,
  label,
}: {
  projectId: string;
  history: GateHistoryView[];
  currentBuildId?: string;
  label: string;
}) {
  return (
    <ul aria-label={label} className="divide-y divide-border/60">
      {history.map((h) => (
        <li
          key={h.id}
          className="flex flex-wrap items-center gap-x-4 gap-y-1.5 py-2.5"
        >
          <GateStatusChip status={h.status} className="justify-start sm:w-44" />
          <Link
            to={`/projects/${projectId}/walkthroughs/builds/${h.buildId}`}
            className="min-w-0 max-w-64 truncate font-semibold text-foreground underline-offset-4 hover:underline"
          >
            {h.label}
          </Link>
          {h.buildId === currentBuildId && (
            <Chip tone="outline">This build</Chip>
          )}
          <span className="text-sm tabular-nums text-muted-foreground">
            {severityTotal(h.counts.new)} new · {severityTotal(h.counts.fixed)}{" "}
            fixed · {severityTotal(h.counts.regressed)} regressed
          </span>
          <Timestamp
            date={h.lastRunAt}
            className="ml-auto text-xs tabular-nums text-muted-foreground"
          />
        </li>
      ))}
    </ul>
  );
}
